import React, { useEffect, useState } from "react";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import { toastError } from "../../utils/toastUtils";

const UserModal = ({ onSave, allRoles, initialData }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [userRoles, setUserRoles] = useState([]);

  const isEditMode = !!initialData?.email;

  const [userData, setUsersData] = useState({
    email: initialData?.email || "",
    first_name: initialData?.first_name || "",
    last_name: initialData?.last_name || "",
    password: ""
  });

  const handleUserData = (e) => {
    setUsersData({ ...userData, [e.target.name]: e.target.value });
  };

  const addRoleToUser = (obj) => {
    setSelectedRole(obj.id);
    if (userRoles.some((role) => role.id === obj.id)) {
      toastError("Already assigned");
      return;
    }
    setUserRoles([...userRoles, { id: obj.id, name: obj.name }]);
  };

  const deleteRoleFromUser = (role) => {
    setUserRoles(userRoles.filter((userRole) => userRole.id !== role.id));
  };

  useEffect(() => {
    if (isEditMode && allRoles?.length > 0) {
      const newRolesArray = allRoles
        .filter((role) => initialData.roles?.includes(role.id))
        .map((role) => ({ id: role.id, name: role.name }));

      setUserRoles(newRolesArray);
    }
  }, [initialData, allRoles, isEditMode]);

  const handleSubmit = () => {
    onSave(userData, userRoles);
  };

  return (
    <div>
      <div className="builder_form">
        <Input
          label="First Name"
          placeholder="Enter First Name"
          name="first_name"
          value={userData.first_name}
          onChange={handleUserData}
        />
        <Input
          label="Last Name"
          placeholder="Enter Last Name"
          name="last_name"
          value={userData.last_name}
          onChange={handleUserData}
        />

        {!isEditMode && (
          <>
            <Input
              label="Email"
              type="email"
              placeholder="Enter Email"
              name="email"
              value={userData.email}
              onChange={handleUserData}
            />
            <Input
              label="Password"
              type="password"
              placeholder="Enter Password"
              name="password"
              value={userData.password}
              onChange={handleUserData}
            />
          </>
        )}

        <SingleSelectBox
          selectedData={selectedRole}
          options={allRoles || []}
          onChange={(obj) => addRoleToUser(obj)}
          placeholder="Select role"
          label="Assign Role"
        />

        <div>
          {userRoles.length > 0 ? (
            userRoles.map((role) => (
              <div key={role.id} className="role_card">
                <span>{role.name}</span>
                <MaterialIcon
                  name="delete"
                  className="builder_action_btn delete"
                  onClick={() => deleteRoleFromUser(role)}
                />
              </div>
            ))
          ) : (
            <div className="builder_label font_weight_medium">No Role Assigned</div>
          )}
        </div>

        <Button onClick={handleSubmit}>{isEditMode ? "Edit User" : "+ Add User"}</Button>
      </div>
    </div>
  );
};

export default UserModal;
